import React from 'react'
import Typography from '@material-ui/core/Typography'
import Grid from '@material-ui/core/Grid'
import { useStyles } from './styles'
import { numberWithCommas } from '../../../../utils'

const ProgressInformation = ({ data: { learners } }) => {
  const classes = useStyles()
  const pace = learners.progress.pace

  return (
    <Grid container item xs={12} className={classes.generalInfo}>
      <Grid container alignItems='center' justifyContent='center' item xs={4} className={classes.item}>
        <div className={classes.block}>
          <div className={classes.amount}>
            <Typography variant='h1' component='div'>
              {pace && pace.ahead + pace.behind + pace.onTrack !== 0
                ? `${numberWithCommas(
                    (Math.round(((pace.ahead + pace.onTrack) / (pace.ahead + pace.behind + pace.onTrack)) * 100 + Number.EPSILON) * 10) / 10
                  )}%`
                : '0%'}
            </Typography>
          </div>
          <div className={classes.label}>
            <Typography variant='h5' component='div'>
              % Ahead / On Track
            </Typography>
          </div>
        </div>
      </Grid>
      <Grid container alignItems='center' justifyContent='center' item xs={4} className={classes.item}>
        <div className={classes.block}>
          <div className={classes.amount}>
            <Typography variant='h1' component='div'>
              {numberWithCommas(Math.round((learners.progress.medianStepsPerUser + Number.EPSILON) * 10) / 10)}
            </Typography>
          </div>
          <div className={classes.label}>
            <Typography variant='h5' component='div'>
              Median Steps Completed
            </Typography>
          </div>
        </div>
      </Grid>
      <Grid container alignItems='center' justifyContent='center' item xs={4} className={classes.item}>
        <div className={classes.block}>
          <div className={classes.amount}>
            <Typography variant='h1' component='div'>
              {numberWithCommas(Math.round((learners.progress.avgDaysPerStep + Number.EPSILON) * 10) / 10)}
            </Typography>
          </div>
          <div className={classes.label}>
            <Typography variant='h5' component='div'>
              Average Days per Step
            </Typography>
          </div>
        </div>
      </Grid>
    </Grid>
  )
}

export default ProgressInformation
